<template>
  <div class="mb-header">
    <slot name="left" >
      <img class="mb-back" @click="goBack" src="~assets/images/exam/icon-back.png"/>
    </slot>
    <div class="mb-title-wrap">
      <slot name="middle" >
        <span class="mb-title">
         {{title}}
        </span>
      </slot>
    </div>
    <slot name="right"></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    back: Function
  },
  methods: {
    goBack() {
      if (this.back) {
        this.back()
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.mb-header{
  width: 100%;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  background: #fff;
  position: relative;
  position: sticky; // ios Nemo app 不支持
  top: 0;
  z-index: 10;
  .mb-left{
    font-size: 32px;
    font-weight: 400;
    color: #666666;
  }
  .mb-title-wrap{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .mb-title{
    font-size: 36px;
    font-weight: 500;
    color: #333333;
    letter-spacing: 1px;
  }
  .mb-back{
    width: 16px;
    height: 26px;
  }
}
</style>
